<div>
  <div class="modal-header d-flex flex-row justify-content-between">
    <div class="h4 p-2">
       Error(s)
    </div>
    <button type="button" class="close m-0 p-1" aria-label="Close" (click)="closeModal()">
        <span>&times;</span>
    </button>
  </div>

  <div class="modal-body text-center py-2 mb-1">
    <error-panel [errorEvents]="errorEvents" [errorEvent]="errorEvent" (errorDeleted)="errorDeleted$.emit($event)"></error-panel>
  </div>

  <div class="modal-footer mt-0">
    <div class="d-flex flex-row justify-content-end">
      <button type="button" class="btn btn-warning mr-2" (click)="errorEvents.length=0;closeModal()" >Clear</button>
      <button type="button" class="btn btn-secondary" (click)="closeModal()" >Close</button>
    </div>
  </div>

</div>
